<app-page-heading [key]="(mode == _displayMode_.Creation ? 'reports.form.page-title.creation' : 'reports.form.page-title.edition')"></app-page-heading>

<section class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-8">
                    <button type="button" class="btn btn-primary btn-outline btn-lg pull-left" (click)="location.back()">
                        <span class="fa fa-arrow-left"> </span>
                    </button>&nbsp;
                </div>
                <div class="col-xs-4" *ngIf="mode == _displayMode_.Edition">
                    <div class="input-group-btn text-right" [ngClass]="{'open' : isActionDropdownOpen}">
                        <button class="btn btn-primary btn-lg dropdown-toggle" (click)="isActionDropdownOpen = !isActionDropdownOpen" type="button">
                            <span [i18n]="[{target: 'innerHTML', key: 'reports.form.actions.label'}]"></span><span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right">
                            <li>
                                <a class="dropdown-item" (click)="openConfirmDelete(deleteModal); isActionDropdownOpen = !isActionDropdownOpen"
                                   [i18n]="[{target: 'innerHTML', key: 'reports.form.actions.delete'}]"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <br>

            <div class="ibox float-e-margins">
                <div class="ibox-content border-primary">
                    <form #myForm="ngForm" (submit)="processForm()" novalidate class="row">
                        <fieldset [disabled]="formProcessingBlocked" class="col-xs-12">
                            <div class="form-group">
                                <label class="control-label" for="reportName" [i18n]="[{target: 'innerHTML', key: 'reports.form.name'}]"></label>
                                <input class="form-control input-lg" name="reportName" id="reportName" type="text" [(ngModel)]="report.name"
                                       #reportNameInput="ngModel" aria-describedby="reportNameHelp" required>
                                <label class="error" *ngIf="reportNameInput.dirty && reportNameInput.errors?.required"
                                       [i18n]="[{target: 'innerHTML', key: 'validation.required'}]">
                                </label>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="regions" [i18n]="[{target: 'innerHTML', key: 'reports.form.regions.label'}]"></label>
                                <ng-select class="regions-select form-control input-lg"
                                           name="regions"
                                           id="regions"
                                           [items]="allRegions"
                                           bindLabel="name"
                                           [addTag]="false"
                                           [i18n]="[{target: 'attribute:placeholder', key: 'reports.form.regions.placeholder'}]"
                                           notFoundText="Region not found"
                                           [hideSelected]="true"
                                           [multiple]="true"
                                           [(ngModel)]="report.assignedRegions">
                                </ng-select>
                            </div>
                            <div class="form-group">
                                <label class="control-label" for="reportId" [i18n]="[{target: 'innerHTML', key: 'reports.form.report-id'}]"></label>
                                <input class="form-control input-lg" name="reportId" id="reportId" type="text"
                                       [(ngModel)]="report.powerBiId" required
                                       #reportIdInput="ngModel" aria-describedby="reportIdHelp">
                                <label class="error" *ngIf="reportIdInput.dirty && reportIdInput.errors?.required"
                                       [i18n]="[{target: 'innerHTML', key: 'validation.required'}]">
                                </label>
                            </div>

                            <div class="form-buttons">
                                <button type="submit" class="btn btn-primary btn-lg pull-right" [disabled]="myForm.invalid || myForm.pristine">
                                    <span class="fa fa-save space-right-5"></span>
                                    <span [i18n]="[{target: 'innerHTML', key: (mode == _displayMode_.Creation ? 'reports.form.buttons.create' : 'reports.form.buttons.update')}]"></span>
                                </button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>

        </div>
    </div>
</section>

<ng-template #deleteModal>
    <span [i18n]="[{target: 'innerHTML', key: 'reports.form.modals.delete.content'}]"></span>
</ng-template>
